<script setup lang="ts">
import { dashboardApiClient } from '@api-client/dashboard';
import { Button } from '@/components/ui/button';
import { toast } from '@/ui-plus/sonner';
import { Zap } from 'lucide-vue-next';

const isDev = import.meta.env.DEV;

const props = defineProps<{
    websiteId: string;
}>();

const emit = defineEmits<{
    reload: [];
}>();

const setAvailableOnTsNow = async () => {
    const response = await (await dashboardApiClient.website.partner_marketing.dev_set_marketing_incoming_available_on_ts_now[':websiteId'].$post({
        param: { websiteId: props.websiteId },
    })).json();
    if (response.error) {
        console.error(response.error);
        toast.error('Failed to set availableOnTs to now');
        return;
    }
    toast.success('availableOnTs set to now');
    emit('reload');
};

const runProcessPartnerBalancesCron = async () => {
    const response = await (await dashboardApiClient.website.partner_marketing.dev_run_process_partner_balances_cron[':websiteId'].$post({
        param: { websiteId: props.websiteId },
    })).json();
    if (response.error) {
        console.error(response.error);
        toast.error('Failed to run processPartnerBalances cron');
        return;
    }
    toast.success('processPartnerBalances_CronHandler_Store completed');
    emit('reload');
};
</script>

<template>
    <details v-if="isDev"
             class="mt-6">
        <summary>
            <Zap class="h-5 w-5 text-yellow-500 inline-block cursor-pointer" />
            Debug Actions
        </summary>
        <div class="space-y-3 p-4 border rounded-lg mt-2">
            <Button @click="setAvailableOnTsNow"
                    variant="secondary">
                Set availableOnTs to now
            </Button>
            <Button @click="runProcessPartnerBalancesCron"
                    variant="secondary">
                processPartnerBalances_CronHandler_Store
            </Button>
        </div>
    </details>
</template>
